import { storyblokEditable, StoryblokComponent } from "@storyblok/react";

const ListItem = ({ blok }) => {
  return (
    <div className="grid" {...storyblokEditable(blok)}>
      {blok.item.map((nestedBlok) => (
        <StoryblokComponent blok={nestedBlok} key={nestedBlok._uid} />
      ))}
    </div>
  );
};

export default ListItem;
